import SVGInjector from "../../../node_modules/svg-injector/dist/svg-injector.min.js";

export function inject() {
  var mySVGsToInject = document.querySelectorAll('img.inject-me');
  SVGInjector(mySVGsToInject);
}
